// extracted by mini-css-extract-plugin
export default {"danger":"#f13a42","heart":"Custom_heart__JgbP+"};